import config from 'config';

/**
 * Checks if url is valid
 * @param string
 */
export function isValidUrl(string: string) {
  try {
    // eslint-disable-next-line no-new
    new URL(string);
  } catch (_) {
    return false;
  }

  return true;
}

/**
 * Checks if route is not part of our FE routes
 * @param route
 */
export function isFEroute(route: string) {
  route = route.startsWith('/') ? route : '/' + route;
  const feRoutes: string[] = config.get('feRoutes');

  return feRoutes.some((feRoute) => {
    const cleanFeRoute = feRoute.replace(/\/\[(.*?)\]/gim, '');

    return cleanFeRoute && cleanFeRoute === route;
  });
}

/**
 * Converts string to safe url for us
 * @param string
 */
export function stringTosafeUrl(string: string) {
  return string
    .replace(/õ/gim, 'õ')
    .replace(/ä/gim, 'a')
    .replace(/ö/gim, 'o')
    .replace(/ü/gim, 'u')
    .replace(/[^A-Za-z0-9-]+/gim, '');
}

/**
 * Concerst category name or tag to url
 * @param categoryName
 */
export function categoryNameToUrl(categoryName: string) {
  return categoryName?.toLowerCase()?.replace(/\s/gim, '-');
}

/**
 * Percent-encodes a value for use as a URL path segment.
 *
 * Deliberately keeps `&` raw. It is a legal sub-delimiter in a path, several category
 * slugs contain one (bloggers-&-influencers, books-&-magazines, sports-&-leisure), and
 * every in-app link builds those URLs without encoding it. Using encodeURIComponent
 * unchanged would emit /category/bloggers-%26-influencers, which is a different URL from
 * the one the site links to, so canonicals would point away from the served page and
 * every click on those categories would take a needless redirect.
 */
export function encodePathSegment(value: string) {
  return encodeURIComponent(value ?? '').replace(/%26/g, '&');
}

/**
 * Get hostname without 'www.'
 */
export function getHostname() {
  return (typeof window !== 'undefined' && window.location.hostname.slice(window.location.hostname.indexOf('.') + 1)) || 'Yaga';
}

/**
 * Checks if a hostname ends with a specific domain
 * @param hostname - The hostname to check
 * @param domain - The domain to check against
 * @returns boolean - True if hostname ends with the domain
 */
export function hostnameEndsWithDomain(hostname: string, domain: string): boolean {
  return hostname.endsWith(`.${domain}`);
}
